import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { start, end } from "config/redux/slice";

import { ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";
import { AppUtils } from "utils";

import { handleErrorWithTokenRenewal } from "./common";

const { API_V1_BANK_CREDIT_REQUESTS } = ServerConstants;

const {
  REQUEST_BANK_CREDIT_VIEW_ID,
  REQUEST_BANK_CREDIT_NEW_ID,
  REQUEST_BANK_CREDIT_OPTIONS_ID,
  REQUEST_BANK_CREDIT_UPDATE_MULTIPLE_PROPERTIES_ID
} = ServiceConstants;

const CANTON_FIELD_NAMES = new Set(["canton", "previousCanton", "mortgageCanton"]);

export async function bankCreditNew(creditId: number) {
  const requestId = REQUEST_BANK_CREDIT_NEW_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(`${API_V1_BANK_CREDIT_REQUESTS}/${creditId}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, bankCreditNew, [creditId], requestId);
  }
}

export async function bankCreditOne(id: number) {
  const requestId = REQUEST_BANK_CREDIT_VIEW_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_BANK_CREDIT_REQUESTS}/${id}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, bankCreditOne, [id], requestId);
  }
}

export async function bankCreditOptions() {
  const requestId = REQUEST_BANK_CREDIT_OPTIONS_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_BANK_CREDIT_REQUESTS}/options`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, bankCreditOptions, [], requestId);
  }
}

export async function bankCreditUpdateMultipleProperties(id: number, data: any) {
  const requestId = REQUEST_BANK_CREDIT_UPDATE_MULTIPLE_PROPERTIES_ID;
  try {
    store.dispatch(start(requestId));
    const body: { name: string, value: any }[] = [];
    Object.keys(data).forEach((el) => {
      const rawValue = data[el as any];
      const normalizedValue = CANTON_FIELD_NAMES.has(el)
        ? AppUtils.getSwissCantonCode(rawValue) ?? rawValue
        : rawValue;

      body.push({ name: el, value: AppUtils.convertToAppropriateValue(normalizedValue) });
    });
    const response = await APIKit.patch(`${API_V1_BANK_CREDIT_REQUESTS}/${id}/multiple`, body); //or PUT ?
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, bankCreditUpdateMultipleProperties, [id, data], requestId);
  }
}
